export const SERVICE_STATUSES = () => ({ ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE' });



// WEBPACK FOOTER //
// ./src/app/merchants/services/services.constants.js